<template lang="pug">
.feature
  .row.apart
    .col(v-if="showVote")
      .feature-vote(
        @click.prevent="vote(thisFeature)",
        :class="{ liked: thisFeature.isLiked }"
      )
        .feature-vote-top
          .feature-vote-icon
            font-awesome-icon.icon(:icon="['fas', 'caret-up']")
          .feature-vote-count
            span {{ thisFeature.stats.likes }}
        //-.feature-vote-button
          span Vote

    .col.max
      .row.apart.center.feature-title
        .col
          h3 {{ thisFeature.name }}

      .feature-status(v-if="thisFeature.status && !thisFeature.status.default")
        StatusLabel(:status="thisFeature.status")

      .feature-body(v-html="descriptionFormatted")

      .feature-attachment(v-if="thisFeature.attachmentUrl")
        a(target="_blank", @click.stop, :href="thisFeature.attachmentUrl")
          img(:src="thisFeature.attachmentUrl")

    .col.feature-comments(v-if="showComments")
      font-awesome-icon.feature-comments-icon(:icon="['fad', 'comments']")
      span {{ thisFeature.stats.comments }}
</template>

<script>

export default {
  name: 'BoardFeature',
  components: {
  },
  props: {
    feature: Object,
    type: {
      type: String,
      default: 'Board'
    }
  },
  data () {
    return {
      thisFeature: {
        stats: {},
        creator: {}
      }
    }
  },
  mounted () {
    this.thisFeature = this.feature
    //console.log(this.thisFeature)
  },
  computed: {
    descriptionFormatted () {
      return this.thisFeature.description ? this.thisFeature.description.replace(/\n/g, '<br/>') : ''
    },
    showVote () {
      return ['changelog'].indexOf(this.type) === -1
    },
    showComments () {
      return ['changelog'].indexOf(this.type) === -1
    }
  },
  methods: {
    vote (feature) {
      const slug = this.thisFeature.slug
      if (this.thisFeature.isLiked) {
        this.$store.dispatch('features/unvoteFeature', slug).then(() => {
          //this.thisFeature.stats.likes--
          //this.thisFeature.isLiked = false
        }, () => {

        })
      } else {
        this.$store.dispatch('features/voteFeature', slug).then(() => {
          //this.thisFeature.stats.likes++
          //this.thisFeature.isLiked = true
        }, () => {
          console.log('womp womp')
        })
      }
    }
  },
  watch: {
    feature (updated) {
      this.thisFeature = updated
    }
  }
}
</script>

<style scoped lang="stylus">

  .feature
    //border-bottom $border-default
    display block
    margin-bottom $spacing-2
    padding $spacing 0

    +for_breakpoint(mobile)
      border-bottom $border-default

    //h3
    //  color $color-primary

    .feature-vote
      border $border-default
      border-radius $border-radius
      cursor pointer
      font-size $spacing-2
      margin-top 3px
      margin-right $spacing-3
      //padding $spacing-2 0
      overflow hidden
      text-align center
      transition 100ms linear
      width 50px

      +for_breakpoint(mobile)
        margin-right $spacing-2


      &.liked
        border-color $color-primary
        .feature-vote-icon
          color $color-primary
        .feature-vote-count
          color $text-default

      &:hover
        border-color $color-primary

      .feature-vote-top
        padding 5px 0 $spacing 0

      .feature-vote-icon
        color $color-black-lighter
        font-size 22px
        .icon
          height 22px

      .feature-vote-count
        //border $border-default
        //border-bottom none
        color $color-black-lighter
        //width 50px
      .feature-vote-button
        background-color $background-color-dark
        color #FFF
        font-size $text-size-smaller
        padding 2px
        text-align center
    .feature-comments
      margin-left $spacing-3
      line-height 26px
      font-size 18px
      .feature-comments-icon
        height 18px
        margin-right $spacing
    .feature-title
      margin-bottom 15px
      .col
        h3
          font-size 22px
          line-height 26px
          +for_breakpoint(mobile)
            font-size 18px
            //line-height 18px
    .feature-status
      margin-bottom $spacing
      margin-top -5px
    //.feature-description
    //  padding 1rem 0

    .feature-body
      color $text-light
      line-height 22px
      margin-bottom $spacing-4

      +for_breakpoint(mobile)
        margin-bottom $spacing-2
      //padding $spacing 0


    .feature-attachment
      img
        max-width 100px

    .feature-footer
      color $text-light

      .feature-footer-avatar
        width 50px

      .creator
        font-size $text-size-small
        line-height $text-size-default
      .created
        font-size $text-size-smaller
        line-height $text-size-default

      span
        display inline-block
        margin-right $spacing
</style>
